<template>
      <div>
        <b-icon v-if="data.approve" icon="check" variant="success" animation="throb" font-scale="8" />
        <b-icon v-else icon="x" variant="danger" animation="throb" font-scale="8" />
        <hr>
        <h3 class="mb-0">  {{$t('general.sure')}} </h3>
        <p v-if="data.approve" > {{$t('customer.approvement.approveCustomerText')}} </p>
        <p v-else> {{$t('customer.approvement.approveCustomerText2')}} </p>
        <b-input :placeholder="$t('customer.approvement.approvementNote')" v-model="description"  />
   </div>
</template>

<script>
    export default {
        name: "AccountDelete",
        data:function(){
            return{
                description: ""
            }
        },
        props:{
            data: Object,
            modalName: String,
            modalEvent: Function,
            save: Boolean,
            saveState: Function,
            onComplete: Function,
            formName: String
        },
        watch:{
            save: async function(data){
                if(data){
                    let params = {
                        id: this.data.ID,
                        comment: this.description,
                        is_approve: this.data.approve
                    }
                    await this.$store.dispatch('customerApprove', params)
                    this.onComplete();
                    this.modalEvent(false)
                }
                this.saveState(false)
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/General/Customer/modals/ApproveCustomer.vue